import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { VersionInfoIcon } from "../../../assets/constants";

const VersionApproveContent = () => {
  return (
    <Stack gap="24px">
      <Stack
        bgcolor="rgba(223, 239, 255, 0.20)"
        padding="16px"
        border="1px solid #EBEBEB"
        gap="8px"
        borderRadius="4px"
      >
        <Box display="flex" gap="8px">
          <VersionInfoIcon />
          <Stack gap="8px">
            <Typography variant="body2" color="#0A3F73" fontWeight={500}>
              CMS Compliant Notice
            </Typography>
            <Typography variant="body2" color="#212121">
              In accordance with CMS requirements, this care plan must be
              reviewed, directed, and signed by the supervising physician before
              it is considered official.
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};

export default VersionApproveContent;
